import hyphenize from '../string/hyphenize';

/**
 * All the properties we need to transition for sliding animation
 */
export const SLIDE_PROPS = [
  'maxHeight',
  'paddingTop',
  'paddingBottom',
  'marginTop',
  'marginBottom'
];

/**
 * Sets up sliding transition for an element.
 * e.g. ['maxHeight', 'paddingTop'] => 'max-height 300ms, padding-top 300ms'
 * @param el - The element to apply slide transition to
 * @param speed - The speed to transition
 */
export function setSlideTransition(el, speed) {
  el.style.transition = SLIDE_PROPS.map(prop => `${hyphenize(prop)} ${speed}ms`).join(', ');
}
